<template>
  <v-container  grid-list-xs class="mt-4">
    <v-row align="center" justify="center">
      <v-col cols="12" align="center" >
        <div>
          <h1>Registro de participante</h1>
        </div>
      </v-col>
    </v-row>

    <v-row align="center" justify="center" class="mt-5">
      <v-col cols="12" lg="5" xl="5" align="center" v-show="peridoAbierto">
        <div>
          <h4>Ingresa tu email para comenzar con el proceso de registro:</h4>
        </div>
        <v-form ref="formRegistro" v-model="validR" @submit.prevent>
          <v-text-field class="mt-3" outlined label="Email" :rules="[rules.required, rules.validEmail]" :maxlength="50" v-model="email" prepend-inner-icon="mdi-email"></v-text-field>
          <div class="text-center mt-1" justify="center" align="center" >
            <v-btn :disabled="!validR" color="primary" @click="checaCorreo()" type="submit">Registrarme</v-btn>
          </div>
        </v-form>
      </v-col>
      <v-col cols="12" lg="5" xl="5" align="center" v-show="!peridoAbierto">
        <v-alert type="warning" color="orange" max-width="350">El periodo de inscripciones está cerrado</v-alert>
      </v-col>
    </v-row>
            
    <v-row align="center" justify="center" class="mt-5">
      <v-col cols="12" align="center" >
        <div>
          <h1>Consulta de datos</h1>
        </div>
      </v-col>
    </v-row>

    <v-row align="center" justify="center" class="mt-5">
      <v-col cols="12" lg="5" xl="5" align="center" >
        <div>
          <h4>Ingresa tu folio para recuperar tus datos:</h4>
        </div>
        <v-form ref="formConsulta" v-model="validC" @submit.prevent>
          <v-text-field class="mt-3" outlined label="Folio" :rules="[rules.required, rules.validFolio]" :maxlength="8" v-model="folio" prepend-inner-icon="mdi-account-search"></v-text-field>
          <!-- <div class="text-center mt-1" justify="center" align="center" >
            <v-btn :disabled="!validC" color="error" type="submit" @click="validaFolio()">Consultar</v-btn>
          </div> -->
        </v-form>
      </v-col>
    </v-row>

    <v-dialog v-model="registro" width="1000" persistent>
      <v-card>
        <v-toolbar dark style="background-color: #1c3d6c" >
          <v-btn icon color="white" @click="closeRegistro()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Registro de participante</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5 pb-0">
          <v-container v-show="emailRegistrado == false && registroExitoso == false">
            <v-form ref="formSolicitudRegistro" v-model="validSR" @submit.prevent> 
              <v-container style="max-width: 1200px;">
                <v-row>
                  <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Nombre" v-model="nombre" :rules="[rules.required]" :maxlength="50" @input="nombre = $event.toUpperCase()"></v-text-field>
                  </v-col>

                   <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Apellido Paterno" v-model="apellidoPaterno" :rules="[rules.required]" :maxlength="50"  @input="apellidoPaterno = $event.toUpperCase()"></v-text-field>
                  </v-col>

                   <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Apellido Materno" v-model="apellidoMaterno" :rules="[rules.required]" :maxlength="50" @input="apellidoMaterno = $event.toUpperCase()"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="12" xl="12">
                    <v-text-field outlined label="Correo" disabled v-model="email" :rules="[rules.required, rules.validEmail]" :maxlength="50"></v-text-field>
                  </v-col>

                </v-row>

                <v-row>
                  <v-col cols="12" lg="4" xl="4">
                    <!-- <v-text-field outlined label="Fecha Nacimiento" v-model="fechaNacimiento" :rules="[rules.required]" type="date"></v-text-field> -->
                    <v-menu ref="menu" v-model="menu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="fechaNacimiento" label="Fecha Nacimiento" readonly v-bind="attrs" v-on="on" outlined :rules="[rules.required]" ></v-text-field>
                      </template>
                      <v-date-picker v-model="fechaNacimiento" :active-picker.sync="activePicker" :max="fechaMax" min="1950-01-01" @change="save"></v-date-picker>
                    </v-menu>
                  </v-col>
                   <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Telefono Fijo" v-model="telefonoFijo" :rules="[rules.required, rules.validNumber]" :maxlength="10"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Telefono Celular" v-model="telefonoCelular" :rules="[rules.required, rules.validNumber]" :maxlength="10"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <!-- <v-col cols="12" lg="6" xl="6">
                    <v-text-field outlined label="Direccion" v-model="direccion" :rules="[rules.required]" :maxlength="50" @input="direccion = $event.toUpperCase()"></v-text-field>
                  </v-col> -->

                  <v-col cols="12" lg="6" xl="6">
                    <v-text-field outlined label="Escuela" v-model="escuela" :rules="[rules.required]" :maxlength="50" @input="escuela = $event.toUpperCase()"></v-text-field>
                  </v-col>

                   <v-col cols="12" lg="6" xl="6">
                    <v-text-field outlined label="Colonia de la escuela" v-model="colonia" :rules="[rules.required]" :maxlength="50" @input="colonia = $event.toUpperCase()"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="6" xl="6">
                    <v-text-field outlined label="Código Postal de la escuela" v-model="codigoPostal" :rules="[rules.required, rules.validCP]" :maxlength="5"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="6" xl="6">
                    <v-select :items="itemsEstados" outlined label="Estado de la escuela" v-model="estado" :rules="[rules.required]"></v-select>
                  </v-col>

                  <v-col cols="12" lg="12" xl="12" v-if="estado == 'Ciudad de México'">
                    <v-select :items="itemsAlcaldias" outlined label="Alcaldia de la escuela" v-model="alcaldia" :rules="[rules.required]"></v-select>
                  </v-col>

                  <v-col cols="12" lg="12" xl="12" v-if="estado == 'Estado de México'">
                    <v-select :items="itemsMunicipios" outlined label="Municipio de la escuela" v-model="municipio" :rules="[rules.required]"></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="6" xl="6">
                    <v-select :items="itemsNivelEscolar" outlined label="Nivel escolar" v-model="nivelEscolar" :rules="[rules.required]"></v-select>
                  </v-col>
                  <v-col cols="12" lg="6" xl="6">
                    <v-select :items="itemsNivelParticipacion" outlined label="Nivel de participación" v-model="nivelParticion" :rules="[rules.required]"></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="12" xl="12">
                    <v-text-field outlined label="Tutor/Asesor" v-model="tutor" :maxlength="50" @input="tutor = $event.toUpperCase()"></v-text-field>
                  </v-col>
                  <!-- <v-col cols="12" lg="6" xl="6"> -->
                    <v-select :items="itemsSedes" outlined label="Sede" v-model="sede" :rules="[rules.required]" class="d-none"></v-select>
                  <!-- </v-col> -->
                </v-row>
              </v-container>
            </v-form>
          </v-container>
          <v-container v-show="registroExitoso == true">
            <v-row justify="center">
              <v-alert type="success" class="text-center" max-width="350">Tu datos fueron guardados con éxito, tu folio es: {{folioRegistro}}</v-alert>
            </v-row>
          </v-container>

          <v-container v-show="emailRegistrado == true">
            <v-row justify="center">
              <v-alert type="info" class="text-center" max-width="350">Este correo ya fue registrado con el folio: {{folioRegistrado}}</v-alert>
            </v-row>
          </v-container>

        </v-card-text>
        <v-card-actions class="pb-5 mr-5">
            <v-spacer></v-spacer>
            <v-btn  v-show="registroExitoso == false && emailRegistrado == false" :disabled="!validSR" color="success" class="mr-4" type="submit" @click="registraParticipante()">Registrarme</v-btn>
            <v-btn  v-show="registroExitoso" color="info" class="mr-4" @click="generaComprobanteRegistro()">Imprime tu Comprobante</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="consulta" width="1000" persistent>
      <v-card>
        <v-toolbar dark style="background-color: #1c3d6c" >
          <v-btn icon color="white" @click="closeConsulta()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Consulta de datos</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5 pb-0">
          <v-container>
            <v-form ref="formModificacionDatos" v-model="validMD" @submit.prevent> 
              <v-container style="max-width: 1200px;">
                <v-row>
                  <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Nombre" v-model="nombreC" :rules="[rules.required]" :maxlength="50" :disabled="!habilitaModificacionDatos" @input="nombreC = $event.toUpperCase()"></v-text-field>
                  </v-col>

                   <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Apellido Paterno" v-model="apellidoPaternoC" :rules="[rules.required]" :maxlength="50" :disabled="!habilitaModificacionDatos" @input="apellidoPaternoC = $event.toUpperCase()"></v-text-field>
                  </v-col>

                   <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Apellido Materno" v-model="apellidoMaternoC" :rules="[rules.required]" :maxlength="50" :disabled="!habilitaModificacionDatos" @input="apellidoMaternoC = $event.toUpperCase()"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="6" xl="6">
                    <v-text-field outlined label="Correo" disabled v-model="emailC" :rules="[rules.required, rules.validEmail]" :maxlength="50"></v-text-field>
                  </v-col>

                </v-row>

                <v-row>
                  <v-col cols="12" lg="4" xl="4">
                    <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="fechaNacimientoC" label="Fecha Nacimiento" readonly v-bind="attrs" v-on="on" outlined :rules="[rules.required]" :disabled="!habilitaModificacionDatos"></v-text-field>
                      </template>
                      <v-date-picker v-model="fechaNacimientoC" :active-picker.sync="activePicker" :max="fechaMax" min="1950-01-01" @change="save2"></v-date-picker>
                    </v-menu>
                    <!-- <v-text-field outlined label="Fecha Nacimiento" v-model="fechaNacimientoC" :rules="[rules.required]" type="date" :disabled="!habilitaModificacionDatos"></v-text-field> -->
                  </v-col>
                   <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Telefono Fijo" v-model="telefonoFijoC" :rules="[rules.required, rules.validNumber]" :maxlength="10" :disabled="!habilitaModificacionDatos"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="4" xl="4">
                    <v-text-field outlined label="Telefono Celular" v-model="telefonoCelularC" :rules="[rules.required, rules.validNumber]" :maxlength="10" :disabled="!habilitaModificacionDatos"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="6" xl="6">
                    <!-- <v-text-field outlined label="Direccion" v-model="direccionC" :rules="[rules.required]" :maxlength="50" :disabled="!habilitaModificacionDatos" @input="direccionC = $event.toUpperCase()"></v-text-field> -->
                  </v-col>

                   <v-col cols="12" lg="6" xl="6">
                    <v-text-field outlined label="Colonia de la escuela" v-model="coloniaC" :rules="[rules.required]" :maxlength="50" :disabled="!habilitaModificacionDatos" @input="coloniaC = $event.toUpperCase()"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="3" xl="3">
                    <v-text-field outlined label="Código Postal de la escuela" v-model="codigoPostalC" :rules="[rules.required, rules.validCP]" :maxlength="5" :disabled="!habilitaModificacionDatos"></v-text-field>
                  </v-col>

                  <v-col cols="12" lg="4" xl="4">
                    <v-select :items="itemsEstados" outlined label="Estado de la escuela" v-model="estadoC" :rules="[rules.required]" :disabled="!habilitaModificacionDatos"></v-select>
                  </v-col>

                  <v-col cols="12" lg="12" xl="12" v-if="estadoC == 'Ciudad de México'">
                    <v-select :items="itemsAlcaldias" outlined label="Alcaldia de la escuela" v-model="alcaldiaC" :rules="[rules.required]" :disabled="!habilitaModificacionDatos"></v-select>
                  </v-col>

                  <v-col cols="12" lg="12" xl="12" v-if="estadoC == 'Estado de México'">
                    <v-select :items="itemsMunicipios" outlined label="Municipio de la escuela" v-model="municipioC" :rules="[rules.required]" :disabled="!habilitaModificacionDatos"></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="12" xl="12">
                    <v-text-field outlined label="Escuela" v-model="escuelaC" :rules="[rules.required]" :maxlength="50" :disabled="!habilitaModificacionDatos" @input="escuelaC = $event.toUpperCase()"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" xl="6">
                    <v-select :items="itemsNivelEscolar" outlined label="Nivel escolar" v-model="nivelEscolarC" :rules="[rules.required]" :disabled="!habilitaModificacionDatos"></v-select>
                  </v-col>
                  <v-col cols="12" lg="6" xl="6">
                    <v-select :items="itemsNivelParticipacion" outlined label="Nivel de participación" v-model="nivelParticionC" :rules="[rules.required]" :disabled="!habilitaModificacionDatos"></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" lg="6" xl="6">
                    <v-text-field outlined label="Tutor/Asesor" v-model="tutorC" :maxlength="50" :disabled="!habilitaModificacionDatos" @input="tutorC = $event.toUpperCase()"></v-text-field>
                  </v-col>
                  <v-col cols="12" lg="6" xl="6">
                    <v-select :items="itemsSedes" outlined label="Sede" v-model="sedeC" :rules="[rules.required]" :disabled="!habilitaModificacionDatos" class="d-none"></v-select>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12">
                    <v-alert type="info" width="auto" min-width="215" max-width="400" class="text-center" text>Fecha de inscripción: {{fechaActualizacion}}</v-alert>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions class="pb-5 mr-5">
          <v-row align="center" justify="end">
            <v-col v-if="peridoAbierto && !habilitaModificacionDatos" cols="12"  lg="4" xl="4" class="d-flex justify-end">
              <v-btn color="success" class="mr-4" type="submit" @click="habilitaModificacionDatos = true">Modificar Datos</v-btn>
            </v-col>
            <v-col v-if="habilitaModificacionDatos" cols="12" lg="4" xl="4" class="d-flex justify-end">
              <v-btn  :disabled="!validMD" color="success" class="mr-4" type="submit" @click="modificaDatos()">Guardar Cambios</v-btn>
            </v-col>
            <v-col v-if="!habilitaModificacionDatos" cols="12" lg="4" xl="4" class="d-flex justify-end">
              <v-btn color="info" class="mr-4" @click="generaComprobanteConsulta()">Imprime tu Comprobante</v-btn>
            </v-col>
          </v-row>
            <!-- <v-spacer></v-spacer>
            
            -->
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-model="dialogClose" max-width="500px" persistent>
      <v-card>
        <v-card-title class="text-h5 text-center">¿Estas seguro de cerrar esta ventana?, los datos ingresados se eliminaran</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancelarClose">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="cerrarVentanaConsulta">Continuar</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div>
      <v-snackbar v-model="mensaje" centered :color="color" timeout="2000"> 
        <v-row justify="center" align="center">
          <v-col cols="3" class="text-center">
            <v-icon size="50">mdi-check-circle-outline</v-icon>
          </v-col>
          <v-col cols="9" class="text-h6 text-center">
            {{texto}}
          </v-col>
        </v-row>
      </v-snackbar>
    </div>
  </v-container>  
</template>

<script>
import { createForm, baseURL } from '@/general'
import axios from 'axios'

export default {
  metaInfo: {
    title: 'Olimpiada de Quimica',
    titleTemplate: 'Inscripcion - %s',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },
  data: () => ({
    activePicker: null,
    date: null,
    menu: false,
    fechaMax: '',
    menu2: false,
    dialogClose: false,
    //variables para fechas de inscripcion
    fechaInicioInscripcion: '',
    fechaFinInscripcion: '',
    peridoAbierto: false,
    emailRegistrado: false,
    folioRegistrado: '',
    // variables para los primeros datos
    email: '',
    folio: '',
    validR: '',
    validC: '',
    // variables para la solictud de registro
    validSR: '',
    registro: false,
    nombre: '',
    apellidoPaterno: '',
    apellidoMaterno: '',
    email: '',
    fechaNacimiento: '',
    telefonoFijo: '',
    telefonoCelular: '',
    direccion: '',
    colonia: '',
    estado: '',
    alcaldia: '',
    municipio: '',
    codigoPostal: '',
    escuela: '',
    nivelEscolar: '',
    nivelParticion: '',
    tutor: '',
    sede: '',
    registroExitoso: false,
    folioRegistro: '',

    // variables para la consulta de datos
    validMD: '',
    consulta: false,
    nombreC: '',
    apellidoPaternoC: '',
    apellidoMaternoC: '',
    emailC: '',
    fechaNacimientoC: '',
    telefonoFijoC: '',
    telefonoCelularC: '',
    direccionC: '',
    coloniaC: '',
    estadoC: '',
    alcaldiaC: '',
    municipioC: '',
    codigoPostalC: '',
    escuelaC: '',
    nivelEscolarC: '',
    nivelParticionC: '',
    tutorC: '',
    sedeC: '',
    fechaActualizacion: '',
    habilitaModificacionDatos: false,

    rules: {
      required: v => !!v || 'Este dato no puede estar vacio',
      validEmail: v => /\S+@\S+\.\S+/.test(v) || 'Email inválido',
      validCP: v => /^\d{4,5}$/.test(v) || 'Codigo Postal invalido',
      validNumber: v => /^\d{10}$/.test(v) || 'Solo números',
      validFolio: v => /^\d{8}$/.test(v) || 'Folio incorrecto',
    },
    //items 
    itemsEstados: [],
    itemsAlcaldias: [],
    itemsMunicipios: [],
    itemsNivelEscolar: [],
    itemsNivelParticipacion: [],
    itemsSedes: [],
    // mensaje 
    mensaje: false,
    color: '',
    texto: ''
  }),

  created(){
    this.getCatalogos()
    this.getFechas()
    const now = new Date()
    const fechaMaxima = new Date()
    fechaMaxima.setFullYear(now.getFullYear() - 10)
    this.fechaMax = fechaMaxima.toISOString().slice(0,10)  
  },

  watch: {
    folio(){
      if(this.folio.length == 8) {
        this.validaFolio()
      }
    },

    menu (val) {
        val && setTimeout(() => (this.activePicker = 'YEAR'))
      },
  },

  methods: {
    save (date) {
      this.$refs.menu.save(date)
    },

    save2 (date) {
      this.$refs.menu2.save(date)
    },

    async getCatalogos(){
      let response = await this.catalogo(createForm({tabla:'estado'}))

      // A partir del 2025 solamente se considerará solamente la Ciudad de México y el Estado de México
      for (const i in response) {
        if(response[i].nombre != 'Ciudad de México' && response[i].nombre != 'Estado de México'){
          continue
        }
        this.itemsEstados.push(response[i].nombre)
      }

      response = await this.catalogo(createForm({tabla:'alcaldia'}))
      for (const i in response) {
        this.itemsAlcaldias.push(response[i].nombre)
      }

      response = await this.catalogo(createForm({tabla:'municipio'}))
      for (const i in response) {
        this.itemsMunicipios.push(response[i].nombre)
      }

      response = await this.catalogo(createForm({tabla:'nivel_escolar'}))
      for (const i in response) {
        this.itemsNivelEscolar.push(response[i].nivel_escolar)
      }

      response = await this.catalogo(createForm({tabla:'nivel_participacion'}))
      for (const i in response) {
        this.itemsNivelParticipacion.push(response[i].nivel)
      }

      // Solamente se considera la sede sin sede debido a que actualmente solo se ofrece la sede sin sede
      response = await this.catalogo(createForm({tabla:'sede'}))
      for (const i in response) {
        if(response[i].status == '1' && response[i].sede == 'Sin sede'){
          this.itemsSedes.push(response[i].sede)
        }
      }
      this.sede = this.itemsSedes[0]
    },

    catalogo(data){
      return new Promise((resolve, reject) => {
        axios.post('catalogos.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    async getFechas(){
      let response = await this.fechas()
      this.fechaInicioInscripcion = response[0].fecha
      this.fechaFinInscripcion = response[1].fecha
      const today = new Date().toISOString().slice(0,10)
      if(today >= this.fechaInicioInscripcion && today <= this.fechaFinInscripcion){
        this.peridoAbierto = true
      }
    },

    fechas(){
      return new Promise((resolve, reject) => {
        axios.post('fechas.php')
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    async checaCorreo(){
      let response = await this.buscaRegistro(createForm({email: this.email}))
      if (response.state == '1') {
        this.emailRegistrado = true
        this.folioRegistrado = response.folio
      }else if (response.state == '2') {
        this.emailRegistrado = false
        this.registroExitoso = false
      }
      this.registro = true
    },

    buscaRegistro(data){
      return new Promise((resolve, reject) => {
        axios.post('buscaRegistro.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    async registraParticipante(){
      if(this.$refs.formSolicitudRegistro.validate() == true){
        if (this.estado == 'Ciudad de México') {
          this.municipio = null
        }else if(this.estado == 'Estado de México'){
          this.alcaldia = null
        }else{
          this.alcaldia = null
          this.municipio = null
        }
        let response = await this.mandaSolicitud(createForm({nombre: this.nombre,
                                                             apellidoPaterno: this.apellidoPaterno,
                                                             apellidoMaterno: this.apellidoMaterno,
                                                             email: this.email,
                                                             fechaNacimiento: this.fechaNacimiento,
                                                             telefonoFijo: this.telefonoFijo,
                                                             telefonoCelular: this.telefonoCelular,
                                                             direccion: this.direccion,
                                                             colonia: this.colonia,
                                                             estado: this.estado,
                                                             alcaldia: this.alcaldia,
                                                             municipio: this.municipio,
                                                             codigoPostal: this.codigoPostal,
                                                             escuela: this.escuela,
                                                             nivelEscolar: this.nivelEscolar,
                                                             nivelParticion: this.nivelParticion,
                                                             tutor: this.tutor,
                                                             sede: this.sede}))
        if(response.state == '1'){
          this.registroExitoso = true
          this.folioRegistro = response.folio
        } else if (response.status == '2'){
          this.mensaje = true
          this.texto = 'Error al realizar el registro, tus datos no pueden ser vacios'
          this.color = 'error'
        } else if (response.state == '3'){
          this.mensaje = true
          this.texto = 'El periodo de inscripción ha finalizado'
          this.color = 'error'
        } else if (response.state == '4' || response.state == '5'){
          this.mensaje = true
          this.texto = 'Ocurrio un error interno, intentalo más tarde'
          this.color = 'error'
        } else if (response.state == '6'){
          this.emailRegistrado = true
          this.registroExitoso = false
          this.folioRegistrado = response.folio
        } 
      }
    },

    mandaSolicitud(data){
      return new Promise((resolve, reject) => {
        axios.post('registraParticipante.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },
    
    closeRegistro(){
      this.dialogClose = true
    },

    closeConsulta(){
      this.dialogClose = true
    },

    cancelarClose(){
      this.dialogClose = false
    },

    cerrarVentanaConsulta(){
      this.dialogClose = false
      this.registro = false
      // this.$refs.formSolicitudRegistro.reset()
      // this.$refs.formRegistro.reset()
      this.emailRegistrado = false
      this.registroExitoso = false
      this.email = ''

      this.consulta = false
      // this.$refs.formModificacionDatos.reset()
      // this.$refs.formConsulta.reset()
      this.habilitaModificacionDatos = false
      this.folio =  ''
    },

    async validaFolio(){
      let response = await this.consultaDatosFolio(createForm({folio: this.folio}))
      
      if (response.state == '1') {
        if (response.tutor == 'N/A') {
          response.tutor = ''
        }if (response.alcaldia == 'NULL') {
          response.alcaldia = ''
        }if (response.municipio == 'NULL') {
          response.municipio = ''
        }
        this.nombreC = response?.nombre?.toUpperCase() || ''
        this.apellidoPaternoC = response?.apellido_paterno?.toUpperCase()  || ''
        this.apellidoMaternoC = response?.apellido_materno?.toUpperCase() || ''
        this.emailC = response.correo_electronico
        this.fechaNacimientoC = response.fecha_nacimiento
        this.telefonoFijoC = response.telefono_casa
        this.telefonoCelularC = response.telefono_celular
        this.direccionC = response?.direccion?.toUpperCase() || ''
        this.coloniaC = response?.colonia?.toUpperCase() || ''
        this.estadoC = response.estado
        this.alcaldiaC = response.alcaldia
        this.municipioC = response.municipio
        this.codigoPostalC = response.codigo_postal
        this.escuelaC = response?.escuela?.toUpperCase() || ''
        this.nivelEscolarC = response.nivelEscolar
        this.nivelParticionC = response.nivelParticipacion
        this.tutorC = response?.tutor?.toUpperCase() || ''
        this.sedeC = response.sede
        this.fechaActualizacion = response.fechaInscripcion
        this.consulta = true
        
      }else if (response.state == '2') {
        this.mensaje = true
        this.color = 'error'
        this.texto = 'No se encontró el aspirante con este número de folio'
      }
    },

    consultaDatosFolio(data){
      return new Promise((resolve, reject) => {
        axios.post('consultaDatos.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    async modificaDatos(){
      if(this.$refs.formModificacionDatos.validate() == true){
        if (this.estadoC == 'Ciudad de México') {
          this.municipioC = null
        }else if(this.estadoC == 'Estado de México'){
          this.alcaldiaC = null
        }else{
          this.alcaldiaC = null
          this.municipioC = null
        }
        if (this.tutorC == '') {
          this.tutorC = 'N/A'
        }
        let response = await this.mandaActualizacion(createForm({ nombre: this.nombreC,
                                                                  apellidoPaterno: this.apellidoPaternoC,
                                                                  apellidoMaterno: this.apellidoMaternoC,
                                                                  email: this.emailC,
                                                                  fechaNacimiento: this.fechaNacimientoC,
                                                                  telefonoFijo: this.telefonoFijoC,
                                                                  telefonoCelular: this.telefonoCelularC,
                                                                  direccion: this.direccionC,
                                                                  colonia: this.coloniaC,
                                                                  estado: this.estadoC,
                                                                  alcaldia: this.alcaldiaC,
                                                                  municipio: this.municipioC,
                                                                  codigoPostal: this.codigoPostalC,
                                                                  escuela: this.escuelaC,
                                                                  nivelEscolar: this.nivelEscolarC,
                                                                  nivelParticion: this.nivelParticionC,
                                                                  tutor: this.tutorC,
                                                                  sede: this.sedeC,
                                                                  folio: this.folio}))
        if(response.state == '1'){
          this.mensaje = true
          this.texto = 'Datos modificados con éxito'
          this.color = 'success'
          this.cerrarVentanaConsulta()
        } else if (response.status == '2'){
          this.mensaje = true
          this.texto = 'Error al realizar el registro, tus datos no pueden ser vacios'
          this.color = 'error'
          this.cerrarVentanaConsulta()
        } else if (response.state == '3'){
          this.mensaje = true
          this.texto = 'El periodo de inscripción ha finalizado, no es posible modificar tus datos'
          this.color = 'error'
          this.cerrarVentanaConsulta()
        } else if (response.state == '4' || response.state == '5'){
          this.mensaje = true
          this.texto = 'Ocurrio un error interno, intentalo más tarde'
          this.color = 'error'
          this.cerrarVentanaConsulta()
        }
      }
    },

    mandaActualizacion(data){
      return new Promise((resolve, reject) => {
        axios.post('modificaParticipante.php', data)
        .then((response) => {
            resolve(response.data);
        }).catch((error) => reject(error));
      });
    },

    generaComprobanteConsulta(){
      let url = baseURL + `/comprobante/generaComprobante.php?folio=${btoa(this.folio)}`
      location.href=url
    },

    generaComprobanteRegistro(){
      let url = baseURL + `/comprobante/generaComprobante.php?folio=${btoa(this.folioRegistro)}`
      location.href=url
    },
  }
}
</script>

<style>

</style>